





















































import { defineComponent, type PropType } from "vue-demi";
import type { Product } from "@constructor/shared-entity/type";
import GGPrice from "./GGPrice.vue";
import ProductDiscountMarker from "../shared/ProductDiscountMarker.vue";
import BonusCount from "../shared/BonusCount/BonusCount.vue";

export default defineComponent({
  name: "GGProductPromo",
  components: {
    GGPrice,
    ProductDiscountMarker,
    BonusCount,
  },
  props: {
    items: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    /**
     * Число выводимых товаров в сетке
     */
    count: {
      type: Number as PropType<1 | 2 | 3 | 4 | 5 | 6 | 9>,
      default: 1,
    },
    /**
     * С какой стороны выводить большую картинку
     */
    productAlign: {
      type: String as PropType<"right" | "left">,
      default: "right",
    },
  },
  computed: {
    countProduct() {
      if (this.count > this.items?.length) {
        return Math.min(6, this.items.length);
      } else {
        return this.count;
      }
    },
  },
});
